import { render, staticRenderFns } from "./IndexSale.vue?vue&type=template&id=2f7ab7d7&scoped=true"
import script from "./IndexSale.vue?vue&type=script&lang=js"
export * from "./IndexSale.vue?vue&type=script&lang=js"
import style0 from "./IndexSale.vue?vue&type=style&index=0&id=2f7ab7d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ab7d7",
  null
  
)

export default component.exports